// Note: localization for MUI data grid and MUI date picker can be added into this file too.
import { arEG, deDE, enUS, esES, frFR, itIT, jaJP, nlNL, ptBR, zhCN, type Localization } from '@mui/material/locale';
import {
  deDE as datePickerDeDE,
  enUS as datePickerEnUS,
  esES as datePickerEsES,
  frFR as datePickerFrFR,
  itIT as datePickerItIT,
  jaJP as datePickerJaJP,
  nlNL as datePickerNlNL,
  ptBR as datePickerPtBR,
  zhCN as datePickerZhCN,
  type PickersInputLocaleText,
} from '@mui/x-date-pickers/locales';
import 'dayjs/locale/ar';
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/ja';
import 'dayjs/locale/nl';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/zh-cn';

export const muiLocales: Record<string, Localization[]> = {
  ar: [arEG],
  de: [deDE],
  en: [enUS],
  es: [esES],
  fr: [frFR],
  it: [itIT],
  ja: [jaJP],
  nl: [nlNL],
  pt: [ptBR],
  zh: [zhCN],
};

type DatePickerLocaleBundle = typeof datePickerEnUS;
const getLocaleText = (bundle: DatePickerLocaleBundle) =>
  bundle.components.MuiLocalizationProvider.defaultProps.localeText;

// @mui/x-date-pickers ships no Arabic bundle, so its picker text falls back to English.
export const datePickerLocaleText: Record<string, PickersInputLocaleText | undefined> = {
  ar: undefined,
  de: getLocaleText(datePickerDeDE),
  en: getLocaleText(datePickerEnUS),
  es: getLocaleText(datePickerEsES),
  fr: getLocaleText(datePickerFrFR),
  it: getLocaleText(datePickerItIT),
  ja: getLocaleText(datePickerJaJP),
  nl: getLocaleText(datePickerNlNL),
  pt: getLocaleText(datePickerPtBR),
  zh: getLocaleText(datePickerZhCN),
};

export const dayjsLocale: Record<string, string> = {
  ar: 'ar',
  de: 'de',
  en: 'en',
  es: 'es',
  fr: 'fr',
  it: 'it',
  ja: 'ja',
  nl: 'nl',
  pt: 'pt-br',
  zh: 'zh-cn',
};
